namespace $.$$ {
	export class $shm_hitalama_benchmarks_page_metrics_details extends $.$shm_hitalama_benchmarks_page_metrics_details {
		@ $mol_mem override popup_width_max() {
			const viewport = this.$.$mol_window.size()
			const trigger = this.Trigger().view_rect()
			const available = !trigger ? viewport.width - 32 : this.align_hor() === 'left'
				? trigger.right - 16
				: viewport.width - trigger.left - 16
			return Math.max(32, Math.min(512, viewport.width - 32, available))
		}
		override bubble_offset() {
			const offset = [...super.bubble_offset()]
			// Align the corresponding edges of the trigger and the popup.
			// Using the opposite trigger edge pushes a wide popup off screen.
			if (this.align().startsWith('bottom_') || this.align().startsWith('top_')) {
				if (this.align_hor() === 'left') offset[0] = 1
				if (this.align_hor() === 'right') offset[0] = 0
			}
			return offset
		}
	}
}
